import { createApp } from "vue";
import App from "./index.vue";
import './index.less';
import "swiper/swiper-bundle.min.css";
import "./post.ts";
createApp(App)
  .mount("#app");
